import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileWarning, Mail, CalendarClock } from "lucide-react";

const dayLabel = (n) => {
  if (n < 0) return `visita passata da ${-n} g`;
  if (n === 0) return "visita oggi";
  if (n === 1) return "visita domani";
  return `visita tra ${n} giorni`;
};

export const IntakePendingCard = () => {
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState(null);
  useEffect(() => {
    api.get("/referto/intake-pending").then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, []);
  if (!items || items.length === 0) return null;
  const remind = async (it) => {
    setBusy(it.id);
    try {
      await api.post(`/referto/intake-returns/${it.id}/remind`);
      toast.success(`Promemoria inviato a ${it.to_email}`);
      setItems((prev) => prev.map((p) => (p.id === it.id ? { ...p, reminders_sent: (p.reminders_sent || 0) + 1 } : p)));
    } catch (e) { toast.error(e.response?.data?.detail || "Invio non riuscito"); }
    finally { setBusy(null); }
  };
  return (
    <Card className="mt-4 md:mt-6 p-3 md:p-5 rounded-xl border-amber-200 shadow-sm bg-white" data-testid="dashboard-intake-pending">
      <div className="flex items-center gap-2 mb-3">
        <div className="h-9 w-9 rounded-lg bg-amber-50 text-amber-700 border border-amber-200 flex items-center justify-center"><FileWarning className="h-5 w-5" /></div>
        <div>
          <h3 className="font-heading text-base md:text-lg font-bold text-slate-900">Moduli non riconsegnati</h3>
          <p className="text-xs text-slate-500">{items.length} pazient{items.length === 1 ? "e" : "i"} con visita entro 2 giorni senza modulo di accoglienza</p>
        </div>
      </div>
      <ul className="divide-y divide-slate-100">
        {items.map((it) => (
          <li key={it.id} className="py-2.5 flex items-center gap-3 flex-wrap" data-testid={`intake-pending-${it.id}`}>
            <div className="flex-1 min-w-[220px]">
              <div className="font-semibold text-slate-900 text-sm">{it.first_name} {it.last_name}
                <span className="ml-2 text-xs font-normal text-slate-500">{it.to_email}</span></div>
              <div className="mt-1 flex items-center gap-1.5 text-[11px]">
                <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 border ${it.days_to_visit <= 0 ? "bg-red-100 text-red-800 border-red-200" : "bg-amber-100 text-amber-800 border-amber-200"}`}>
                  <CalendarClock className="h-3 w-3" /> {new Date(it.visit_date).toLocaleDateString("it-IT")} · {dayLabel(it.days_to_visit)}
                </span>
                {it.reminders_sent > 0 && <span className="text-slate-500">{it.reminders_sent} promemoria inviat{it.reminders_sent === 1 ? "o" : "i"}</span>}
              </div>
            </div>
            <Button size="sm" variant="outline" disabled={busy === it.id} onClick={() => remind(it)} data-testid={`intake-remind-${it.id}`}
                    className="h-8 text-xs bg-white border-amber-300 text-amber-800 hover:bg-amber-50">
              <Mail className="h-3.5 w-3.5 mr-1" /> {busy === it.id ? "Invio…" : "Reinvia promemoria"}
            </Button>
          </li>
        ))}
      </ul>
    </Card>
  );
};
